<template>
  <div class="pl-5 pr-5 mt-5">
    <div class="title">
      <v-icon class="indent pr-1">mdi-square-medium</v-icon>
      <span class="">{{ title }}</span>
    </div>

    <div class="font-weight-light mt-3">
      <p>
        Společnost ASW Systems, a.s., je nejvetším tuzemským dodavatelem služeb, hardware
        a software pro restaurační, cateringové a hotelové služby.
      </p>
      <p>
        Projekt pro firemní webovou prezentaci je postaven na open source
        <a href="//en.wikipedia.org/wiki/Content_management_system" target="_blank">
          <v-icon>mdi-open-in-new</v-icon>
          <span>CMS</span>
        </a>
        systému
        <a href="//www.dokuwiki.org/dokuwiki" target="_blank">
          <v-icon>mdi-open-in-new</v-icon>
          <span>DokuWiki</span>
        </a>
        s řadou pluginů vlastního vývoje pro napojení na firemní informační systém a Google mapy.
      </p>
      <p>
        Firemní prezentace je provozována na adrese
        <a href="//septim.cz" target="_blank">
          <v-icon>mdi-open-in-new</v-icon>
          <span>septim.cz</span>
        </a>
      </p>
    </div>

    <ImgCarousel :items="images" @click="click"></ImgCarousel>

  </div>
</template>

<script>
  import { call } from 'vuex-pathify';

  import ImgCarousel from "@/components/ImgCarousel";

  export default {
    name: "Asw",
    components: {
      ImgCarousel
    },
    data () {
      return {
        title: 'ASW Systems, a.s. – firemní prezentace',
        images: [
          {
            preview: '/img/refs/asw/01_prv.png',
            src: '/img/refs/asw/01.png',
            description: 'Titulní stránka prezentace',
            alt: ''
          },
          {
            preview: '/img/refs/asw/02_prv.png',
            src: '/img/refs/asw/02.png',
            description: 'Stránka řešení s podnabídkou',
            alt: ''
          },
          {
            preview: '/img/refs/asw/03_prv.png',
            src: '/img/refs/asw/03.png',
            description: 'Stránka produktového portfolia',
            alt: ''
          },
          {
            preview: '/img/refs/asw/04_prv.png',
            src: '/img/refs/asw/04.png',
            description: 'Stránka referencí s vyznačením realizací na Google mapách',
            alt: ''
          },
          {
            preview: '/img/refs/asw/05_prv.png',
            src: '/img/refs/asw/05.png',
            description: 'Vzhled titulní stránky na mobilu',
            alt: ''
          },
          {
            preview: '/img/refs/asw/06_prv.png',
            src: '/img/refs/asw/06.png',
            description: 'Vzhled stránky referencí na mobilu',
            alt: ''
          },
        ]
      }
    },
    methods: {
      ...call('imgGallery', ['setItems', 'showGallery']),
      click (item) {
        this.showGallery({
          items: this.images,
          index: item.index,
          title: this.title
        });
      }
    }
  }
</script>

<style scoped>
  a {
    color: rgba(8, 113, 0, 0.87);
    text-decoration: none;
  }
  a:hover {
    border-bottom: 1px solid;
  }
  a i {
    font-size: 12px!important;
    margin-left: 2px;
    margin-right: 2px;
    margin-top: 1px;
  }
  .indent {
    margin-left: -7px;
    margin-top: -2px;
  }
</style>
